import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as cafesContractActions from '../../../redux/contract/actions';
import submitForm from '../../../utils/submitForm';
import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import ReportListFilter from './reportListFilter';
import './styles.scss';
import Table from '../../../components/table';
import { contractList } from '../../../enums/columns/contract';
import ENUMS from '../../../enums/index';

class CafesContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: locales('errors.default'),
      errorFlag: false,
      currentPage: 1,
      itemsPerPage: 10,
      pageSize: 10,
      cafesContract: [],
      flag: true,
      sortType: 'desc',
      sortBy: 'date',
      download: false,
      ref: React.createRef(),
      data: [],
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  componentDidUpdate(prevProps, prevState) {
    let newContractList = [];
    this.props.cafesContract?.map(item => {
      let newType = '';
      ENUMS.CAFE_TYPE.list.map(enumVal => {
        if (enumVal.value === item.cafeType) {
          newType = enumVal.title;
        }
      });
      let newItem = { ...item, cafeType: newType };
      newContractList = [...newContractList, newItem];
    });
    if (prevState.data.length !== newContractList.length) {
      this.setState({ data: newContractList });
    }
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=date-desc'}`;
      return query;
    }
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  applyFilters = (event, cityCode) => {
    const queryString = submitForm(event, cityCode);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      if (this.state.download) {
        // this.props.getCafesInExcel(searchQuery);
      } else {
        this.props.getCafesContract(searchQuery);
      }
    });
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  onSortCafes = (sortField, sortType) => {
    this.setState(
      { pageNumber: 0, sort: `sort=${sortField}-${sortType}` },
      () => this.filterAndSort(),
    );
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.getCafesContract(query);
    });
  };

  render() {
    let { totalRecords } = this.props.cafeContract;
    let { currentPage, pageSize, itemsPerPage, sortType } = this.state;

    let loading = this.props.loading;
    let error = this.props.error;
    let failed = this.props.failed;
    let message = this.props.message;

    return (
      <Spin spinning={loading}>
        <section className='page-header'>
          <h1>{locales('titles.manage.contract.list')}</h1>
          <div className='form-actions'>
            <Link to='/cafes-contract/add' className='btn btn-primary w-5'>
              <i className='fa fa-plus' />
              {locales('titles.add.new.contract')}
            </Link>
            <a style={{ display: 'none' }} href='empty' ref={this.state.ref}>
              ref
            </a>
          </div>
        </section>

        {this.state.errorFlag && this.handleAlert()}

        <section className='panel panel-default'>
          {error ? (
            <div className='alert alert-danger'>
              {locales('messages.server.error')}
            </div>
          ) : (
            <>
              {failed && <div className='alert alert-danger'>{message}</div>}

              <div className='panel-heading'>
                <i className='fas fa-list-alt px-1' />
                {locales('titles.contract.list')}
              </div>

              <div className='panel-body'>
                <ReportListFilter applyFilters={this.applyFilters} />
                {this.state.data.length === this.props.cafesContract.length && (
                  <Table
                    columns={contractList}
                    dataSource={this.state.data}
                    loading={loading}
                    sort={{ type: sortType, action: this.sortTable }}
                    pagination={{
                      currentPage: currentPage,
                      pageSize: pageSize,
                      totalCount: totalRecords,
                      onPageChange: this.onPageChanged,
                    }}
                  />
                )}
              </div>
            </>
          )}
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.cafesContractReducer.getCafesContractLoading,
    fail: state.cafesContractReducer.getCafesContractFailed,
    error: state.cafesContractReducer.getCafesContractError,
    message: state.cafesContractReducer.getCafesContractMessage,

    cafesContract: state.cafesContractReducer.cafesContract,
    cafeContract: state.cafesContractReducer.cafeContract,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCafesContract: query =>
      dispatch(cafesContractActions.getCafesContract(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CafesContract);
